var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.code === _vm.DDM_WORK_TYPES.STUDIO.value ? _c('div', {
    staticClass: "tabs-wrap tabs-wrap--lg"
  }, [_c('tabs-primary', [_c('tab-primary', {
    attrs: {
      "to": `YONGSIN?code=${_vm.code}`
    }
  }, [_vm._v("신설동(특별장비)")]), _c('tab-primary', {
    attrs: {
      "to": `DAPSIMNI?code=${_vm.code}`
    }
  }, [_vm._v("답십리(공용장비)")])], 1)], 1) : _vm._e(), _c('u-img-txt-items', {
    attrs: {
      "data-aos": "fade",
      "items": _vm.equipments
    }
  }), _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "5"
    },
    on: {
      "input": function ($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }